import { render } from "./CatalogList.vue?vue&type=template&id=2bd27921&scoped=true"
import script from "./CatalogList.vue?vue&type=script&lang=js"
export * from "./CatalogList.vue?vue&type=script&lang=js"

import "./CatalogList.vue?vue&type=style&index=0&id=2bd27921&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd27921"]])

export default __exports__